import { ListSortDirection, Sort } from "../../models/api/sort";
import { TransactionTypeDTO, TransactionTypeSTO } from "../../models/transaction-types";
import { BaseApiService } from "../base/base-api.service";

export class TransactionTypesApiService extends BaseApiService<TransactionTypeDTO, TransactionTypeSTO> {
  constructor() {
    super({
      servicePath: "/TransactionTypes",
      loadItemsPath: "/GetTransactionTypes",
      saveItemsPath: "/SaveTransactionTypes",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
